import { useCallback } from 'react';
import useAutoResizeTextarea from './useAutoResizeTextarea';
import { blockNewlineKey } from '../utils/textareaUtils';

// Change/keydown wiring shared by every auto-growing textarea: resizes right after the
// keystroke (the value effect alone lags when the owner re-renders asynchronously) and
// optionally keeps the value single-line.
const useAutoGrowTextField = ({
  value,
  minHeight,
  onChange,
  onKeyDown,
  singleLine = false,
  externalRef,
}) => {
  const { ref, adjustHeight } = useAutoResizeTextarea({ value, minHeight, externalRef });

  const handleChange = useCallback(
    (event) => {
      if (onChange) onChange(event);
      requestAnimationFrame(adjustHeight);
    },
    [onChange, adjustHeight]
  );

  const handleKeyDown = useCallback(
    (event) => {
      if (singleLine) blockNewlineKey(event);
      if (onKeyDown) onKeyDown(event);
    },
    [singleLine, onKeyDown]
  );

  return { ref, handleChange, handleKeyDown };
};

export default useAutoGrowTextField;
